import React, { useState, useEffect } from 'react';

// Amplify
import { graphqlOperation } from 'aws-amplify';

// Components
import { Button, Table } from 'antd';

// Mock
// import AddItem from './AddItem';
// import EditItem from './EditItem';
import { activitiesByTimesheet, listTimesheets, timesheetsByContractor } from '../../graphql/queries';
import { Link } from 'react-router-dom';
import { History } from 'history';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import { ContractorActivity, TimesheetStatus } from '../../API';
import ActivityModalForm from './ActivityModalForm';
import { Timesheet } from '../../types';
import { ConnectedInfiniteTable } from 'basealpha-ui';

class ActivityTable extends ConnectedInfiniteTable<ContractorActivity, 'activitiesByTimesheet'> {}

type Props = IAppStateComponentProps & { timesheetId: string; timesheet?: Timesheet };
const List = (props: Props): React.ReactElement => {
  const [selectedRecord, setSelectedRecord] = useState<ContractorActivity | undefined>(undefined);
  const queryGenerator = (nextToken: string | null): { query: any; variables: {} } => {
    return graphqlOperation(`
    query ActivitiesByTimesheet(
      $timesheetId: ID
      $sortDirection: ModelSortDirection
      $filter: ModelContractorActivityFilterInput
      $limit: Int
      $nextToken: String
    ) {
      activitiesByTimesheet(
        timesheetId: $timesheetId
        sortDirection: $sortDirection
        filter: $filter
        limit: $limit
        nextToken: $nextToken
      ) {
        items {
          id
          owner
          timesheetId
          description
          assignedBy
          team
          status
          startDate
          endDate
          document
        }
        nextToken
      }
    }
  `, {
      timesheetId: props.timesheetId,
      nextToken,
      limit: 20,
    });
  };

  const refreshTable = () => {
    const event = new Event('refresh#contractor-activity-table');
    window.dispatchEvent(event);
  };

  const closeModal = () => {
    setSelectedRecord(undefined);
  };

  // description
  // assignedBy
  // team
  // status
  // startDate
  // endDate
  // document
  const columns = [
    {
      title: 'Task',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Assigned By',
      dataIndex: 'assignedBy',
      key: 'assignedBy',
    },
    {
      title: 'Team',
      dataIndex: 'team',
      key: 'team',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: 'Expected / Completion Date',
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: 'Link to the document in the archiving folder',
      dataIndex: 'document',
      key: 'document',
    },
  ];
  const isLocked = props.timesheet?.submitted && props.timesheet?.status !== TimesheetStatus.REJECTED;
  return (
    <React.Fragment>
      <br />
      <ActivityTable
        tableId="contractor-activity-table"
        onRowClick={(record: ContractorActivity, rowIndex: number): void => {
          setSelectedRecord(record);
        }}
        columns={columns}
        queryGenerator={queryGenerator}
        opName="activitiesByTimesheet"
      />
      <ActivityModalForm
        record={selectedRecord}
        timesheetId={props.timesheetId}
        onSave={refreshTable}
        close={closeModal}
        showModal={typeof selectedRecord !== 'undefined'}
      />
    </React.Fragment>
  );
};

export default withAppState(List);
